var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLoginButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 230,
    viewBox: "0 0 298 230",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FC5726",
    strokeWidth: 2,
    fill: "#FFF",
    x: 1,
    y: 1,
    width: 296,
    height: 228,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 2.5c2.071 0 3.946.84 5.303 2.197A7.477 7.477 0 0 1 296.5 10v135.5H1.5V10c0-2.071.84-3.946 2.197-5.303A7.477 7.477 0 0 1 9 2.5z",
    fill: "#FC5726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginButton);
export default __webpack_public_path__ + "static/media/bg_login_button.6b99a7f2969773a073df6bc0a0adba97.svg";
export { ForwardRef as ReactComponent };